import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { NgxPermissionsService } from 'ngx-permissions';
import { AppConnectMessageType } from './core/enums/app-connect.enum';
import { PermissionsService } from './core/services/permissions.service';
import { UserService } from './core/services/user.service';
import {
  PermissionCode
} from './shared/const';

@Component({
  selector: 'soctrip-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  adminHubConnectUrl: string = environment.ADMIN_HUB_URL + '/app-connect';
  constructor(
    private router: Router,
    private userService: UserService,
    private ngxPermissionsService: NgxPermissionsService,
    private permissionsService: PermissionsService
  ) {
    this.connectAdminHub();
  }

  @HostListener('window:message', ['$event'])
  receiveMessage(event: any) {
    if (
      event.data.type === AppConnectMessageType.AUTHORIZED &&
      event.origin === environment.ADMIN_HUB_URL
    ) {
      if (!event.data || !event.data.token) {
        window.location.href = environment.ADMIN_HUB_URL;
        return;
      }
      this.save(event.data);
    }

    if (
      event.data.type === AppConnectMessageType.UNAUTHORIZED &&
      event.origin === environment.ADMIN_HUB_URL
    ) {
      window.location.href = environment.ADMIN_HUB_URL;
    }

    if (
      event.data.type === AppConnectMessageType.SUCCESSFUL &&
      event.origin === environment.ADMIN_HUB_URL
    ) {
      localStorage.clear();
      const adminHubUrl = `${environment.ADMIN_HUB_URL}/login`;
      window.location.href = adminHubUrl;
    }
  }

  save(data: any): void {
    localStorage.setItem(environment.TOKEN, JSON.stringify(data.token));
    localStorage.setItem(environment.USER_PROFILE, data.profile);
    localStorage.setItem(environment.AUTH_STATUS, JSON.stringify({ isLoggedIn: true }));
    this.userService.getPermissionCodeList().subscribe(res => {
      if (res.data?.length) {
        this.permissionsService.setEncryptedCache(res.data);
        this.ngxPermissionsService.loadPermissions(res.data);
        if (window.location.pathname === '/') {
          if (
            res.data.includes(PermissionCode.userDashboardAccess) ||
            res.data.includes('SUPER_ADMIN')
          ) {
            this.router.navigate(['/dashboard/user']);
            return;
          }
          if (res.data.includes(PermissionCode.fanpageDashboardAccess)) {
            this.router.navigate(['/dashboard/fanpage']);
            return;
          }
          if (res.data.includes(PermissionCode.groupDashboardAccess)) {
            this.router.navigate(['/dashboard/group']);
            return;
          }
          if (res.data.includes(PermissionCode.adsAccess)) {
            this.router.navigate(['/advertisement/ads-management']);
            return;
          }
          if (res.data.includes(PermissionCode.adsAccountAccess)) {
            this.router.navigate(['/advertisement/ads-accounts-management']);
            return;
          }
          if (res.data.includes(PermissionCode.userManagementAccess)) {
            this.router.navigate(['/user-management']);
            return;
          }
          if (res.data.includes(PermissionCode.groupManagementAccess)) {
            this.router.navigate(['/group-fanpage/group-management']);
            return;
          }
          if (res.data.includes(PermissionCode.fanpageManagementAccess)) {
            this.router.navigate(['/group-fanpage/fanpage-management']);
            return;
          }
          if (res.data.includes(PermissionCode.feeAccess)) {
            this.router.navigate(['/fee-schedule/soctrip-fee']);
            return;
          }
          if (res.data.includes(PermissionCode.feeByRegionAccess)) {
            this.router.navigate(['/fee-schedule/fee-by-region']);
            return;
          }
          if (res.data.includes(PermissionCode.feedbackAccess)) {
            this.router.navigate(['/feedbacks']);
            return;
          }
          if (res.data.includes(PermissionCode.affiliateAccess)) {
            this.router.navigate(['/affiliate-marketer']);
            return;
          }
          if (res.data.includes(PermissionCode.faqAccess)) {
            this.router.navigate(['/faq']);
            return;
          }
          if (res.data.includes(PermissionCode.chatAccess)) {
            this.router.navigate(['/soctrip-chat']);
            return;
          }
          if (res.data.includes(PermissionCode.pinAccess)) {
            this.router.navigate(['/suggested-content']);
            return;
          }
          if (res.data.includes(PermissionCode.livestreamConfigAccess)) {
            this.router.navigate(['/livestream-gift-config']);
            return;
          }
        }
      } else {
        window.location.href = environment.ADMIN_HUB_URL;
      }
    });
  }

  connectAdminHub() {
    const ifr = document.createElement('iframe');
    ifr.classList.add('hidden');
    document.body.appendChild(ifr);
    ifr.src = this.adminHubConnectUrl;
    const connect = () => {
      const result = {
        type: AppConnectMessageType.CONNECT
      };
      ifr.contentWindow?.postMessage(result, { targetOrigin: environment.ADMIN_HUB_URL });
    };
    ifr.onload = connect;
  }
}
